module.exports = __webpack_public_path__ + "static/media/loading_white.a192ae9d.gif";